module.exports = __webpack_public_path__ + "img/no-data-personnel.39951929.svg";